import {match, Pattern} from 'ts-pattern';

import {ScopeValues} from '@dms/api/shared';

export const evaluateTireOrderAuthorizationProfile = (
  scopes: string[],
  evaluatorParams: ScopeValues | undefined
) =>
  match(evaluatorParams)
    .with({authorizationProfileId: 'SKIP'}, () => true)
    .with({authorizationProfileId: Pattern.string}, ({authorizationProfileId}) =>
      scopes.includes(authorizationProfileId)
    )
    .otherwise(() => false);
